import { AssistantPanelContext } from "@/services/modules/assistant";
import { cn } from "@/lib/utils";
import { Compass } from "lucide-react";

function metricToneClass(tone?: string) {
  if (tone === "danger") return "border-red-200 bg-red-50 text-red-700";
  if (tone === "warning") return "border-amber-200 bg-amber-50 text-amber-700";
  if (tone === "info") return "border-blue-200 bg-blue-50 text-blue-700";
  return "border-slate-200 bg-slate-50 text-slate-600";
}

export function ContextSnapshot({ panelContext }: { panelContext?: AssistantPanelContext | null }) {
  if (!panelContext) return null;

  const metrics = panelContext.metrics ?? [];
  const alerts = panelContext.alerts ?? [];

  return (
    <div className="rounded-2xl border border-slate-200 bg-slate-50/80 p-3">
      <div className="flex items-center gap-2 text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-500">
        <Compass className="h-3.5 w-3.5 text-blue-500" />
        Contexto ativo
      </div>
      <div className="mt-2 flex flex-wrap gap-2 text-[11px] text-slate-600">
        {panelContext.screen ? <span>Tela: {panelContext.screen}</span> : null}
        {panelContext.entityType ? <span>Escopo: {panelContext.entityType}</span> : null}
        {panelContext.intentLabel ? <span>Foco: {panelContext.intentLabel}</span> : null}
      </div>
      {panelContext.selectedItems && panelContext.selectedItems.length > 0 && (
        <div className="mt-2.5 flex flex-wrap gap-1.5 items-center">
          <span className="text-[10px] font-semibold text-slate-400 uppercase tracking-wider">Itens:</span>
          {panelContext.selectedItems.map((item) => (
            <span
              key={item.id}
              className="inline-flex items-center gap-1 rounded-md border border-blue-200 bg-blue-50/80 px-2 py-0.5 text-[10px] font-semibold text-blue-700"
            >
              {item.code || item.title}
            </span>
          ))}
        </div>
      )}
      {metrics.length > 0 ? (
        <div className="mt-3 flex flex-wrap gap-2">
          {metrics.slice(0, 4).map((item) => (
            <span
              key={`${item.label}-${String(item.value)}`}
              className={cn("rounded-full border px-2.5 py-1 text-[10px] font-semibold", metricToneClass(item.tone))}
            >
              {item.label}: {item.value}
            </span>
          ))}
        </div>
      ) : null}
      {alerts.length > 0 ? (
        <div className="mt-3 space-y-1.5">
          {alerts.slice(0, 3).map((item) => (
            <div
              key={`${item.label}-${String(item.value)}`}
              className={cn("rounded-xl border px-3 py-2 text-[11px] font-medium", metricToneClass(item.tone))}
            >
              {item.label}: {item.value}
            </div>
          ))}
        </div>
      ) : null}
    </div>
  );
}
